import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import ArrowIcon from '../../assets/svgs/ArrowIcon';

import Api from '../../libs/Api';
import translate from '../../libs/i18n';


import LoadingSection from '../../components/Loading/LoadingSection';

import { WebVisualizerCNNStyle } from './WebVisualizerCNNStyle';

const WebVisualizerCNN = ({ modal, report, pdf }) => {
  const [loading, setLoading] = useState(true);
  const language = useSelector((state) => state.settings.language);
  const [cnnPDF, setCNNPDF] = useState(null);
  const [errorCNNPDF, setErrorCNNPDF] = useState(false);

  useEffect(() => {
    (async () => {

      if(pdf && Object.keys(pdf).length > 0){
        setCNNPDF(pdf);
        setLoading(false);
        return;
      }

      if (report?.id) {
        try{
        const responseCNN = await Api.getPDFCNNById(report?.id);

        if (responseCNN?.status === 200 && responseCNN?.data) {
          const pdfUrl = URL.createObjectURL(new Blob([responseCNN?.data], { type: 'application/pdf' }));
          setCNNPDF(pdfUrl);
        } else {
          setErrorCNNPDF(true)
        }
      }catch{
        setErrorCNNPDF(true)
      }

      setLoading(false);
    }
  })();

  }, [report, pdf]);
  
  return (
    <WebVisualizerCNNStyle>
      {!modal ? (
        <div>
          <div className="back-div">
            <Link to={`/relatorios/${id}`} className="back-link">
              <span className="icon">
                <ArrowIcon />
              </span>
              {translate('back', language)}
            </Link>
          </div>
        </div>
      ) : null}

      {errorCNNPDF ?
        <div className={modal ? 'web-visualizer-modal-container' : 'web-visualizer-container'}>
          <div className="alert alert-danger" role="alert">
              {translate('ohifError', language)}
          </div>
        </div> 
      : null}

      {cnnPDF ? (
        <div className={modal ? 'web-visualizer-modal-container' : 'web-visualizer-container'}>
          <iframe
            id="my-iframe"
            title="Visualização do estudo"
            src={cnnPDF}
            width="100%"
            height="100%"
          />
        </div>
      ) : null}

      {( loading ? <LoadingSection message={translate('loadingPDF', language)} /> : null )}

    </WebVisualizerCNNStyle>
  );
};

WebVisualizerCNN.propTypes = {
  modal: PropTypes.bool,
  report: PropTypes.any,
  pdf: PropTypes.any,
};

WebVisualizerCNN.defaultProps = {
  modal: false,
  report: {},
  pdf: {},
};

export default WebVisualizerCNN;
